/* V36.32 — accès au configurateur depuis toutes les pages et le menu mobile. */
(() => {
  'use strict';
  const anchor = '#recherche-vehicule';
  const normalizePath = path => path.replace(/\/+$/, '') || '/';

  function preservePreview() {
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (!preview) return;
    document.querySelectorAll('a[data-dj-search="vehicle"]').forEach(link => {
      const target = new URL(link.href, location.href);
      if (target.origin !== location.origin) return;
      target.searchParams.set('preview_theme_id', preview);
      const href = target.pathname + target.search + target.hash;
      if (link.getAttribute('href') !== href) link.setAttribute('href', href);
    });
  }

  function revealFinder() {
    const target = document.getElementById('recherche-vehicule');
    if (!target) return;
    target.focus({ preventScroll: true });
    target.scrollIntoView({ block: 'start', behavior: 'auto' });
  }

  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[data-dj-search="vehicle"]');
    if (!link) return;
    const target = new URL(link.href, location.href);
    if (target.origin !== location.origin || normalizePath(target.pathname) !== normalizePath(location.pathname) || !document.getElementById('recherche-vehicule')) return;
    event.preventDefault();
    // Conserver la page et le thème de prévisualisation courants.
    const current = new URL(location.href);
    current.hash = anchor;
    if (location.hash !== anchor) history.pushState(null, '', current);
    const drawer = link.closest('header-drawer');
    const details = drawer?.querySelector('details[open]');
    if (details && typeof drawer.close === 'function') {
      // Attendre la libération du focus et du défilement par le menu natif.
      const onToggle = () => {
        if (details.open) return;
        details.removeEventListener('toggle', onToggle);
        requestAnimationFrame(revealFinder);
      };
      details.addEventListener('toggle', onToggle);
      drawer.close();
    } else {
      revealFinder();
    }
  });

  function onNavigation() {
    preservePreview();
    if (location.hash === anchor) requestAnimationFrame(revealFinder);
  }
  window.addEventListener('pageshow', onNavigation);
  window.addEventListener('hashchange', onNavigation);
  document.addEventListener('shopify:section:load', preservePreview);
  const header = document.getElementById('header-group');
  if (header) new MutationObserver(preservePreview).observe(header, { childList: true, subtree: true });
  preservePreview();
})();
